import { useRef } from "react"

let idCounter = 0

// Switch to React.useId when all products are on React 18
export function useId() {
  const idRef = useRef<number | null>(null)
  if (idRef.current === null) {
    idRef.current = idCounter++
  }
  return idRef.current
}
